import type { AuditedEntityDto, PagedAndSortedResultRequestDto } from '@abp/ng.core';
import type { PickUpDto } from '../pick-ups/models';

export interface ChangeClientSommelierDto {
  clientId: number;
  sommelierId: number;
}

export interface ChangeClientSommelierByUserDto {
  userId: string;
  sommelierId: number;
}

export interface ClientSommelierByUserDto {
  clientName: string;
  isClient: boolean;
  currentSommelierId?: number | null;
  currentSommelierName?: string;
  currentSommelierSlug?: string;
  currentSommelierRegion?: string;
  currentSommelierCity?: string;
  currentSommelierFileAttachmentId?: number | null;
}

export interface DisableSommelierWithReassignDto {
  sommelierId: number;
  targetSommelierId?: number | null;
  useInstitutional: boolean;
}

export interface SommelierDeletionInfoDto {
  clientCount: number;
  orderCount: number;
  canHardDelete: boolean;
}

export interface ApproveSommelierDto {
  sommelierId: number;
  email: string;
  name: string;
  surname: string;
  phoneNumber?: string;
  fileAttachmentId?: number;
  bio?: string;
  country?: string;
  region?: string;
  city?: string;
  address?: string;
  specialities?: string;
  certification?: string;
  paymentAccountDetails?: string;
  commissionRate: number;
  pickUpIds: number[];
}

export interface CreateSommelierDto {
  userId: string;
  slug: string;
  profileImageUrl?: string;
  bio?: string;
  country?: string;
  region?: string;
  city?: string;
  address?: string;
  specialities?: string;
  certification?: string;
  paymentAccountDetails?: string;
  commissionRate: number;
  status?: string;
  isActive: boolean;
}

export interface CreateSommelierWithUserDto {
  name: string;
  surname: string;
  email: string;
  phoneNumber?: string;
  slug?: string;
  fileAttachmentId?: number;
  bio?: string;
  country?: string;
  region?: string;
  city?: string;
  address?: string;
  specialities?: string;
  certification?: string;
  paymentAccountDetails?: string;
  commissionRate: number;
  status?: string;
  isActive: boolean;
  pickUpIds: number[];
  academicInstitution?: string;
  instagram?: string;
  postalCode?: string;
}

export interface GetSommelierClientsDto {
  from?: string;
  to?: string;
}

export interface GetSommelierDto extends PagedAndSortedResultRequestDto {
  keyword?: string;
  status?: string;
}

export interface RegisterSommelierDto {
  name: string;
  surname: string;
  email: string;
  phoneNumber: string;
  address: string;
  region: string;
  city: string;
  postalCode: string;
  academicInstitution: string;
  instagram?: string;
}

export interface SommelierClientReportDto {
  userId?: string;
  clientName?: string;
  clientSurname?: string;
  totalPurchases: number;
  lastPurchaseDate?: string;
  phoneNumber?: string;
}

export interface SommelierDto extends AuditedEntityDto<number> {
  userId?: string;
  slug?: string;
  imageUrl?: string;
  fileAttachmentId?: number;
  bio?: string;
  country?: string;
  region?: string;
  city?: string;
  address?: string;
  specialities?: string;
  certification?: string;
  paymentAccountDetails?: string;
  commissionRate: number;
  status?: string;
  isActive: boolean;
  name?: string;
  surname?: string;
  userName?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  email?: string;
  phoneNumber?: string;
  pickUps: PickUpDto[];
  academicInstitution?: string;
  instagram?: string;
  postalCode?: string;
}

export interface UpdateSommelierDto {
  name: string;
  surname: string;
  email: string;
  phoneNumber?: string;
  bio?: string;
  country?: string;
  region?: string;
  city?: string;
  address?: string;
  specialities?: string;
  certification?: string;
  paymentAccountDetails?: string;
  commissionRate: number;
  isActive: boolean;
  pickUpIds: number[];
  fileAttachmentId?: number;
  academicInstitution?: string;
  instagram?: string;
  postalCode?: string;
}

export interface UpdateSommelierSlugDto {
  slug: string;
}

export interface UpdateSommelierWithUserDto {
  name: string;
  surname: string;
  email: string;
  phoneNumber?: string;
  fileAttachmentId?: number;
  bio?: string;
  country?: string;
  region?: string;
  city?: string;
  address?: string;
  specialities?: string;
  certification?: string;
  paymentAccountDetails?: string;
  commissionRate: number;
  status?: string;
  isActive: boolean;
  pickUpIds: number[];
  academicInstitution?: string;
  instagram?: string;
  postalCode?: string;
}
